
import Dialog from './sample-dialog/dialog.js';
import Chart from './chart/dialog.js';

export default [
	Chart,
	Dialog
];
